import { render, staticRenderFns } from "./CollectionSettingModal.vue?vue&type=template&id=2407a492&scoped=true"
import script from "./CollectionSettingModal.vue?vue&type=script&lang=js"
export * from "./CollectionSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407a492",
  null
  
)

export default component.exports